import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-dropdown';
import { GROUP_BY_BUTTON_LABEL, GROUP_BY_BUTTON_CLASS, SORT_BY_BUTTON_LABEL, SORT_BY_BUTTON_CLASS } from '../../redux/constants';


export class DropdownSelection extends Component {
    
    static propTypes = {
        selectedOption: PropTypes.string.isRequired,
        handleSelectionChange: PropTypes.func.isRequired,
        dropdownOptions: PropTypes.array.isRequired,
        buttonLabel: PropTypes.string.isRequired
      }
    
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: '',
            dropdownOptions: [],
            buttonLabel: ''
        };
    }

    componentDidMount() {
        this.setState({
            selectedOption: this.props.selectedOption,
            dropdownOptions: this.props.dropdownOptions,
            buttonLabel: this.props.buttonLabel
          });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            selectedOption: nextProps.selectedOption,
            dropdownOptions: nextProps.dropdownOptions,
            buttonLabel: nextProps.buttonLabel
          });
    }

    _returnButtonWidthClass() {
        const {buttonLabel} = this.state;
        if (buttonLabel === GROUP_BY_BUTTON_LABEL){
            return GROUP_BY_BUTTON_CLASS;
        }
        else if (buttonLabel === SORT_BY_BUTTON_LABEL){
            return SORT_BY_BUTTON_CLASS;
        }
        else {
            return '';
        }
    }

    render() {
        const {
            selectedOption,
            dropdownOptions,
            buttonLabel
        } = this.state;
        const buttonWidthClass = this._returnButtonWidthClass();

        return ( 
            <Dropdown 
                className={`modal-selection-root ${buttonWidthClass}`}
                controlClassName='modal-selection-control'
                arrowClassName='modal-arrow'
                arrowOpen={<span className="modal-arrow" />}
                menuClassName='modal-dropdown-option'
                options={dropdownOptions} 
                onChange={this.props.handleSelectionChange}          
                placeholder={`${buttonLabel}${selectedOption}`}
            />
        )
    }
}

export default DropdownSelection;


// WEBPACK FOOTER //
// ./src/features/home/components/feeds-detail-modal/DropdownSelection.js